define([], function(){
    return {
        PageReady: 'page-ready',
        UpdateMemberInfo: 'update-member-info'
    };
});


//////////////////
// WEBPACK FOOTER
// ../common/events.js
// module id = 6
// module chunks = 0 1 2 3 4 5 6 7 8